import api from './api';

// The home page in one call — see backend dashboardController.
const dashboardService = {
  get: () => api.get('/dashboard').then((r) => r.data),
};

export default dashboardService;
